function NavigateAway(url, menuId, clearSelectedSiteAndPatient) {
    if (clearSelectedSiteAndPatient == null || clearSelectedSiteAndPatient == undefined || typeof (clearSelectedSiteAndPatient) != "boolean")
        clearSelectedSiteAndPatient = false;
    if (menuId != null && menuId != undefined) {
        if (sessionStorage.SelectedMenuItemId != undefined && sessionStorage.SelectedMenuItemId != "undefined" && sessionStorage.SelectedMenuItemId != "null" && sessionStorage.SelectedMenuItemId != menuId) {
            //remove previous selection
            $("#" + sessionStorage.SelectedMenuItemId).removeClass("active");
        }
        sessionStorage.SelectedMenuItemId = menuId;
        $("#" + sessionStorage.SelectedMenuItemId).addClass("active");
    }
    else {
        sessionStorage.SelectedMenuItemId = null;
    }
    if (clearSelectedSiteAndPatient && typeof (GlobalHeaderLeft_ClearSelectedSite) == "function") {
        GlobalHeaderLeft_ClearSelectedSite(url);
    }
    else {
        NavigateAway_Callback(url);
    }
}
function NavigateAway_Callback(url) {
    url = decodeHtml(url);
    if (IsFormDirty()) {
        var ajaxUrl = GetUrlFromAjaxUrlTemplate(baseUrl, "Navigation", "NavigateAway", null);
        if (ajaxUrl != null) {
            $.ajax({
                data: { url: url },
                url: ajaxUrl,
                method: "GET",
                success: function (html) {
                    ShowModal(html)
                },
                error: function (result) {
                    showAlert("Ajax error navigating away", "Error");
                }
            });
        }
    }
    else {
        ResetFormDirtyFlag();
        if (url.indexOf('replaceDivBody') == 0)
            replaceDivBody(url.substring(14))
        else {
            if (url.indexOf('/ICrf/') > 0)
                Kendo_ShowOrHideLoadingImage("divMain", true);
            Global_RenderedFormTypeId = 0;//reset - used by TM only
            window.location = url;
        }
    }
}

//ajaxUrlTemplate is optional and needed only when "NavigateAway" cannot be found in current controller (must use placeholders "___ACT___" for Action and "___CONT___" for controller)
//ajaxUrlController is optional and needed only when "NavigateAway" cannot be found in current controller
//callBackFunction is function name that will be called and it is always required
//after callBackFunction you can add as many as needed optional parameters for callBackFunction
//!!! Never pass complex objects or arrays as parameters for callBackFunction !!!
function NavigateAwayWithCallBack(ajaxUrlTemplate, ajaxUrlController, callBackFunction) {
    var callBack = CreateArguments(callBackFunction, 3, arguments);   
    return NavigateAwayWithCallBackAndCancelCallBack(callBack, null, ajaxUrlTemplate, ajaxUrlController);
}

function NavigateAwayWithCallBackAndCancelCallBackUrl(callBack, cancelCallBack, url) {
    if (sessionStorage.IsFormDirty == undefined || sessionStorage.IsFormDirty == 'undefined' || sessionStorage.IsFormDirty == "null" || !JSON.parse(sessionStorage.IsFormDirty))
        return false;
    if (url != null) {
        $.ajax({
            data: { url: '', callBack: callBack, cancelCallBack: cancelCallBack },
            url: url,
            method: "GET",
            success: function (html) {
                ShowModal(html)
            },
            error: function (result) {
                showAlert("Ajax error navigating away", "Error");
            }
        });
    }
    return true;
}

//this function accepts callbacks as strings
//ex: 'NavigateAwayOk()', 'NavigateAwayCancel()'
function NavigateAwayWithCallBackAndCancelCallBack(callBack, cancelCallBack, ajaxUrlTemplate, ajaxUrlController) {
    if (sessionStorage.IsFormDirty == undefined || sessionStorage.IsFormDirty == 'undefined' || sessionStorage.IsFormDirty == "null" || !JSON.parse(sessionStorage.IsFormDirty)) {
        if (window.OutsideCRFCleanup !== undefined && typeof (window.OutsideCRFCleanup) !== undefined) // if this is called when other than icrf link is clicked(i.e. any other menu item Messages/Run) then make sure we don't call this here.
            window.OutsideCRFCleanup();
        return false;
    }
    var urlLocal = GetUrlFromAjaxUrlTemplate(ajaxUrlTemplate, ajaxUrlController, "NavigateAway", "NavigateAway");
    if (urlLocal != null) {
        jQueryAjax(urlLocal, { url: '', callBack: callBack, cancelCallBack: cancelCallBack }, "GET", ShowModal, showAlert);       
    }
    return true;
}

//$.ajax({
//    data: { url: '', callBack: callBack, cancelCallBack: cancelCallBack },
//    url: urlLocal,
//    method: "GET",
//    success: function (html) {
//        ShowModal(html)
//    },
//    error: function (result) {
//        showAlert("Ajax error navigating away", "Error");
//    }
//});


function decodeHtml(text) {
    return $('<div/>').html(text).text();
}